import classnames from 'classnames';
import React, { FC } from 'react';

import Check from '@/shared/assets/Check';

import styles from './_DropList.module.css';

interface DropListItem {
    title: string;
    id: string;
}

interface DropListProps {
    selectedId: string | undefined;
    items: DropListItem[];
    onItemClick: (itemId: DropListItem['id']) => void;
    className?: string;
    innerRef?: React.MutableRefObject<HTMLUListElement | null>;
}

export const DropList: FC<DropListProps> = ({
    items,
    onItemClick,
    className,
    selectedId = '',
    innerRef = null,
}) => (
    <ul className={classnames(styles.root, styles.fadeIn, className)} ref={innerRef}>
        {items.map(({ title, id }) => {
            const isSelected = id === selectedId;
            return (
                <li className={styles.item}>
                    <button
                        className={styles.button}
                        onClick={() => onItemClick(id)}
                        key={id}
                        aria-current={isSelected ? 'true' : undefined}
                    >
                        {isSelected && <Check className={styles.icon} aria-hidden />}
                        <span className={styles.text}>{title}</span>
                    </button>
                </li>
            );
        })}
    </ul>
);
